/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-14 11:22:01
 * @LastEditTime: 2019-09-10 10:46:05
 * @LastEditors: Please set LastEditors
 */
import Vue from 'vue'
import vuex from 'vuex'
import user from './modules/user'
import base from './modules/base'
Vue.use(vuex)

export default new vuex.Store({
  state: {
    system: '',
    isWeChat: false,
    channel: null, // 页面来源 [0-开机动画,1-首页弹窗,2-Banner,3-feed流,4-搜索词广告,5-PUSH,6-短信,7-站内信,8-微信群,9-朋友圈，10-专栏阅读]
    type: 1,  // 默认为1 ，可以抽奖，0则是不可以抽奖
    userNewApp: true, // 默认使用APP新的交互
    yszActivityStatus: null, // 活动状态【1进行中 2 结束】 
  },
  getters: {
    system (state) {
      return state.system
    },
    isWeChat (state) {
      return state.isWeChat
    },
    channel (state) {
      return state.channel
    },
    userNewApp (state) {
      return state.userNewApp
    },
    yszActivityStatus (state) {
      return state.yszActivityStatus
    }
  },
  modules: {
    user, base
  },
  mutations: {
    useNewAppIt (state, userNewApp) {
      state.userNewApp = userNewApp
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js